import { IMockProps, ErrorResponseCodeType } from '_core/types';
import MocksDef from './MocksDef';

import {
  CODE_ERRORS,
  ENDPOINT_API_PATH,
} from '../Definitions/UpdateMemberSensitiveDataDef';
import { UpdateMemberSensitiveDataTypes } from '../Types';

const autoGenerateSuccess = (
  member: UpdateMemberSensitiveDataTypes.UpdateMemberSensitiveDataServiceRequestType,
) => {
  const validateDocumentSuccess: IMockProps = {
    doc: {
      code: 'Enviado com Sucesso',
      message: 'Enviado com Sucesso',
    },
    configRequest: {
      method: 'PUT',
      path: ENDPOINT_API_PATH,
      body: {
        ...member,
      },
    },
    configResponse: {
      status: 200,
      data: {
        message: 'Atualização solicitada com sucesso',
        serviceRequestNumber: '1-37462957381',
      },
      headers: {},
    },
  };
  return validateDocumentSuccess;
};

const autoGenerateSuccessToken = autoGenerateSuccess({
  firstName: 'Maria',
  lastName: 'Silva',
  birthDate: MocksDef.BIRTHDATE_YYYY_MM_DD,
  attachmentList: MocksDef.ATTACHMENTS,
  contactType: 'EMAIL',
});

const generatedSuccessMocks = [autoGenerateSuccessToken];

const autoGenerate = (firstName: string) => {
  const listOfErrorsMock: IMockProps[] = CODE_ERRORS.map(
    (error: ErrorResponseCodeType, index: number) => {
      const formatedError: IMockProps = {
        doc: {
          code: error.code,
          message: error.message,
        },
        configRequest: {
          method: 'PUT',
          path: ENDPOINT_API_PATH,
          body: {
            attachmentList: MocksDef.ATTACHMENTS,
            firstName: `${firstName}-${index}`,
            contactType: 'EMAIL',
          },
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
          },
          headers: {},
        },
      };

      return formatedError;
    },
  );
  return listOfErrorsMock;
};
const autoGenerateErrorsMock = () => {
  const responseError = autoGenerate('Maria');
  return [...responseError];
};

const errorsGenerated = autoGenerateErrorsMock();

const UpdateMember = [...generatedSuccessMocks, ...errorsGenerated];
export default UpdateMember;
